<template>
  <v-textarea
    v-model="address"
    placeholder="Enter the address"
    rows="4"
    single-line
    filled
    rounded
    dense
    class="rounded-xl"
    hint="Address"
    persistent-hint
  />
</template>

<script>
  import store from '@/store'

  export default {
    name: 'EditSenderNode',
    props: {
      nodeId: {
        type: String,
        default: ''
      },
    },
    computed: {
      address: {
        get () {
          return store.getters.getNodeDataByNodeId(this.nodeId).address
        },
        set (value) {
          store.commit('SET_NODE_DATA_FROM_SELECTED_NODE', { address: value })
        }
      }
    },
  }
</script>

<style scoped>

</style>
